<template>
  <div id="pageContractAgreement" class="mx-auto">
    <v-container fluid class="mt-0 pt-0">
      <v-card
        :loading="this.loading"
        class="mx-auto my-12"
        max-width="1080"
        flat
      >
        <v-card-title class="headline" primary-title>
          Termos do Serviço
        </v-card-title>
        <v-card-text>
          {{
            this.loading
              ? "Carregando..."
              : "Para prosseguir com o seu curso, você precisa aceitar os termos do contrato"
          }}

          <div class="mt-1">
            <v-form ref="form">
              <v-textarea
                v-if="this.course"
                class="contract"
                no-resize
                auto-grow
                v-model="this.course.contract.body"
                filled
                readonly
              ></v-textarea>
              <v-list v-else>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      Nenhum contrato disponível
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-form>
          </div>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="v-card--flat">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            min-width="120"
            @click="submit()"
            :loading="loading"
            :disabled="isOffline"
          >
            {{
              this.isOffline
                ? "Fique online para aceitar os termos"
                : "Li e Aceito"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import EnrollmentService from "../../services/enrollments.service";
import ContractService from "../../services/contractAgreement.service";
import CoursesService from "../../services/courses.service";

export default {
  data() {
    return {
      loading: false,
      course: null,
    };
  },
  mounted() {
    this.loading = true;
    console.log("mounted");
    this.loadContract();
  },

  computed: {
    isOffline() {
      if (!navigator) return false;
      return !navigator.onLine;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      await ContractService.acceptEnrollmentContract(
        this.$route.params.enrollmentId,
      )
        .then((res) => {
          this.sent = true;
          this.$router.push({
            name: "student-area",
            params: {
              courseId: this.course.id,
              slug: this.course.slug,
            },
          });
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e.message);
        });
    },
    loadContract() {
      try {
        CoursesService.getCourseById(this.$route.params.courseId, "contract")
          .then(async (response) => {
            // console.log(response)
            this.course = response.data;
            console.log("loadContract", this.course);
            if (!this.course.contract) {
              await this.submit();
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log("error", error);
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.contract {
  font-family: monospace;
  height: auto;
  max-height: 150%;
  overflow: auto;
}
</style>
